module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_16.a279e8e4.pdf";